angular.module('zc.zenclerkS')
  .component('zcsCampaignEditStepSchedule', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.html',
    require: {
      campaignEdit: '^zcsCampaignEdit'
    },
    controller: ZcsCampaignEditStepScheduleController
  });

ZcsCampaignEditStepScheduleController.$inject = ['$filter', '$scope', '$state'];
function ZcsCampaignEditStepScheduleController($filter, $scope, $state) {
  const vm = this;

  // these are to memorize the value while changing between custom/incentive
  let startAtObj = {};
  let endAtObj = {};

  this.$onInit = () => {
    vm.isNextDisabled = isNextDisabled;
    vm.isInvalidStart = isInvalidStart;
    vm.isInvalidEnd = isInvalidEnd;
    vm.setToNow = setToNow;
    vm.setToBeginningOfNextMonth = setToBeginningOfNextMonth;
    vm.setToBeginningOfNextNextMonth = setToBeginningOfNextNextMonth;
    vm.setToEndOfMonth = setToEndOfMonth;
    vm.setToEndOfNextMonth = setToEndOfNextMonth;
    vm.setToEndOfNextNextMonth = setToEndOfNextNextMonth;
    vm.setCustomSchedule = setCustomSchedule;
    vm.switchEndLimit = switchEndLimit;
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;
    vm.incentive = vm.campaignEdit.incentive;

    vm.minStart = moment().startOf('day').toDate(); //FIXME: not working
    vm.minEnd = moment(vm.campaign.start_at).add(1, 'days').toDate(); //FIXME: not working

    // OEM has no end time limit by default
    if(vm.campaignEdit.isIntegratedWithMakeshop && vm.campaign.incentives.length === 0) {
      vm.campaign.is_infinite = true;
      vm.incentive.is_infinite = true;
    }

    if(!vm.campaign.timing) {
      $state.go('zenclerkS.project.campaign.edit.delivery', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
    }

    if(vm.campaign.start_at) {
      startAtObj = createDateObject(vm.campaign.start_at);
    }
    if(vm.campaign.end_at) {
      endAtObj = createDateObject(vm.campaign.end_at);
    }

    $scope.$watch(() => vm.campaign.start_at_obj.date, newval => {
      if(vm.campaign.start_at_obj.date && !isValidTime(vm.campaign.start_at_obj.time)) {
        vm.campaign.start_at_obj.time = moment().hour() * 60;
      }
    });
    $scope.$watch(() => vm.campaign.end_at_obj.date, newval => {
      if(vm.campaign.is_infinite) return;
      if(vm.campaign.end_at_obj.date && !isValidTime(vm.campaign.end_at_obj.time)) {
        if(vm.campaignEdit.isOem) {
          vm.campaign.end_at_obj.time = 23 * 60; // for OEM the intervals are hourly based
        } else {
          vm.campaign.end_at_obj.time = 23 * 60 + 30;
        }
      }
    });
  };

  function isValidTime(time) {
    return angular.isNumber(time);
  }

  // TODO FIXME: make this unnecessary by developing better date/time component!
  function createDateObject(date) {
    const dateObj = $filter('dateToDateObj')(date);
    return dateObj;
  }

  function isInvalidStart() {
    return _.get(vm.campaign, 'start_at_obj.date') &&
      vm.campaign.status === 'incomplete' &&
      moment().startOf('day').valueOf() > vm.campaign.start_at_obj.date;
  }

  function isInvalidEnd() {
    return !vm.campaign.is_infinite &&
      _.get(vm.campaign, 'start_at_obj.date') &&
      _.get(vm.campaign, 'end_at_obj.date') &&
      vm.campaign.start_at_obj.date > vm.campaign.end_at_obj.date;
  }

  function isNextDisabled() {
    return vm.campaign.useCustomSchedule && (
      !vm.campaign.start_at_obj.date ||
      !isValidTime(vm.campaign.start_at_obj.time) ||
      !vm.campaign.end_at_obj.date ||
      !isValidTime(vm.campaign.end_at_obj.time));
  }

  function setToNow(dateObj) {
    dateObj.date = moment().startOf('day').valueOf();
    dateObj.time = moment().hours() * 60;
  }

  function setToBeginningOfNextMonth(dateObj) {
    dateObj.date = moment().add(1, 'month').startOf('month').valueOf();
    dateObj.time = 0;
  }

  function setToBeginningOfNextNextMonth(dateObj) {
    dateObj.date = moment().add(2, 'months').startOf('month').valueOf();
    dateObj.time = 0;
  }

  function setToEndOfMonth(dateObj) {
    dateObj.date = moment().endOf('month').startOf('day').valueOf();
    dateObj.time = 23 * 60;
  }

  function setToEndOfNextMonth(dateObj) {
    dateObj.date = moment().add(1, 'month').endOf('month').startOf('day').valueOf();
    dateObj.time = 23 * 60;
  }

  function setToEndOfNextNextMonth(dateObj) {
    dateObj.date = moment().add(2, 'months').endOf('month').startOf('day').valueOf();
    dateObj.time = 23 * 60;
  }

  function setCustomSchedule(val) {
    vm.campaign.useCustomSchedule = val;
    if(!vm.campaign.useCustomSchedule) {
      startAtObj = _.merge({}, vm.campaign.start_at_obj);
      endAtObj = _.merge({}, vm.campaign.end_at_obj);
      vm.setToIncentiveStart(vm.campaign.start_at_obj);
      vm.setToIncentiveEnd(vm.campaign.end_at_obj);
    } else {
      vm.campaign.start_at_obj = startAtObj;
      vm.campaign.end_at_obj = endAtObj;
    }
  }

  function switchEndLimit() {
    vm.incentive.is_infinite = !vm.incentive.is_infinite;
    vm.campaign.is_infinite = !vm.campaign.is_infinite;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.js